var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkButton = function SvgLinkButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M33.95 25.485a3 3 0 1 0 4.242 4.243l3.536-3.536a3 3 0 0 0-4.243-4.242l-3.535 3.535zm-1.414-1.414l3.535-3.535a5 5 0 1 1 7.071 7.07l-3.535 3.536a5 5 0 1 1-7.071-7.07zm-9.88 13.121a3 3 0 0 0 4.243 4.243l3.536-3.536a3 3 0 1 0-4.243-4.242l-3.535 3.535zm-1.413-1.414l3.535-3.535a5 5 0 1 1 7.071 7.07l-3.535 3.536a5 5 0 1 1-7.071-7.07zm8.464-.07a1 1 0 0 1-1.414-1.415l6.364-6.364a1 1 0 0 1 1.414 1.414l-6.364 6.364z"
  })));
};
export default SvgLinkButton;